// ── Shared formatters ─────────────────────────────────────────────────────────

export const fmt = (n) =>
  n == null ? '—' : Number(n).toLocaleString('en-NZ', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const fmtCost = (n) =>
  n == null ? '—' : `$${Number(n).toLocaleString('en-NZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const ago = (d) => {
  if (!d) return '—';
  const diff = Math.floor((Date.now() - new Date(d)) / 86400000);
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Yesterday';
  return `${diff}d ago`;
};
